import type { DisplayMarketingCampaign } from "@common/interfaces/KYDMarketing";

/** Body returned by `PUT .../guided-edit` (see `updateGuidedEditPayload` handler). */
export type GuidedEditPutResponse = {
  campaign?: DisplayMarketingCampaign | null;
  update_id?: string;
};

/**
 * Use the persisted campaign from the guided-edit PUT so the detail UI updates
 * immediately; terminal `fetchCampaign({ silent: true })` still reconciles shape.
 */
export function displayCampaignFromGuidedEditPut(
  response: unknown
): DisplayMarketingCampaign | null {
  if (response == null || typeof response !== "object") return null;
  const c = (response as GuidedEditPutResponse).campaign;
  if (c == null || typeof c !== "object") return null;
  return c as DisplayMarketingCampaign;
}

export function guidedEditPutUpdateId(response: unknown): string | undefined {
  if (response == null || typeof response !== "object") return undefined;
  const id = (response as GuidedEditPutResponse).update_id;
  return typeof id === "string" && id.trim() !== "" ? id : undefined;
}
